import React from "react";

type DataDriven = {
    title: string;
    image: string,
    list: string[],
};

type Props = {
    dataDriven : DataDriven[],
    title: React.ReactNode,
    description: string,
}

const PlatformFeatures: React.FC<Props> = ({dataDriven, title, description}) => {
    return (
        <div className={"data-driven-platform"}>
            <div className={"container"}>

                {title}
                <p>{description}</p>

                {
                    dataDriven.map((dataDriven, index) => {
                        return <div className={"d-flex"} key={index}>
                            <div className={"left-block"}>
                                <h3>{dataDriven.title}</h3>
                                <ul>
                                    {
                                        dataDriven.list.map((item, index) => {
                                            return <li key={index}>{item}</li>
                                        })
                                    }
                                </ul>
                            </div>
                            <div className={"right-block"}>
                                <div className={"image-features"}><img src={dataDriven.image} alt={dataDriven.title} width={100} height={100}/></div>
                            </div>
                        </div>
                    })
                }
            </div>
        </div>
    )
}

export default PlatformFeatures;